<template>
    <vx-card :title="pageTitle" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/4 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label"> Интервал </label>
                    <date-picker
                        range
                        v-model="dateInterval"
                        type="datetime"
                        format="YYYY-MM-DD-HH:mm:ss"
                        placeholder="Интервал времени события"
                        :lang="'ru'"
                        :firstDayOfWeek="1"
                        class="date-p w-full"
                    >
                    </date-picker>
                </div>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label">
                        Статус
                    </label>
                    <v-select 
                        :options="dicts.statuses"
                        label="name"
                        placeholder="Выберите статус"
                        class="w-full"
                        v-model="form.statusId"
                        :reduce="s => s.id">
                    </v-select>
                </div>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label">
                        Бренд (DSP)
                    </label>
                    <v-select 
                        :options="dicts.brandTypes"
                        multiple
                        clearable
                        label="name"
                        placeholder="Выберите бренд"
                        class="w-full"
                        v-model="form.brandTypes">
                    </v-select>
                </div>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label">
                        Типы объявлений
                    </label>
                    <v-select 
                        :options="dicts.adTypes"
                        multiple
                        clearable
                        label="name"
                        placeholder="Выберите тип"
                        class="w-full"
                        v-model="form.adTypes">
                    </v-select>
                </div>
            </div>


            <div class="vx-col w-1/4 mb-1">
                <div class="mt-6">
                    <vs-button class="mt-5" color="success" @click="get(true)" type="filled"> Получить </vs-button>
                </div>
            </div>
        </div>

        <vs-table :data="users" :max-items="pageSize" stripe pagination class="mt-5">
            <template slot="header">
            </template>
            <template slot="thead">
                <vs-th class="vs-lg-2"> Пользователь </vs-th>
                <vs-th class="vs-lg-2"> Дата </vs-th>
                <vs-th class="vs-lg-2"> Статус </vs-th>
                <vs-th class="vs-lg-2"> Комментарий </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.userName }}</vs-td>
                    <vs-td>{{ tr.lastExpenseAt | moment('DD.MM.YYYY') }}</vs-td>
                    <vs-td>
                        <div v-if="!tr.statusEdit">
                            <feather-icon icon="Edit2Icon" @click="tr.statusEdit = true" 
                                class="inline-block mr-2 cursor-pointer text-warning" svgClasses="w-7 h-7"/>
                            {{tr.statusName}}
                        </div>
                        <div v-if="!!tr.statusEdit">
                            <div class="vx-col w-full" style="max-width: 250px;">
                                <label>
                                    <select @change="changeStatus(tr.userId)" :id='`user-status-${tr.userId}`'>
                                        <option :selected="tr.statusId == v.id" :key="v.id" :value="v.id" v-for="v in dicts.statuses">
                                            {{v.name}}
                                        </option>
                                    </select>
                                </label>
                            </div>
                        </div>
                    </vs-td>
                    <vs-td>
                        <div class="inline-block cursor-pointer">
                            <vs-input
                                v-model="tr.comment"
                                autocomplete="off"
                                placeholder="Введите комментарий..."
                                class="mt-1 w-full"/>
                        </div>

                        <div class="ml-2 inline-block cursor-pointer comments-block" @click="saveComment(tr.userId, tr.comment)">
                            <vx-tooltip text="Сохранить комментарий">
                                <feather-icon icon="SaveIcon" class="inline-block text-success" svgClasses="w-8 h-8" />
                            </vx-tooltip>
                        </div>
                        <div class="ml-2 inline-block cursor-pointer comments-block" @click="showComments(tr.userId)">
                            <vx-tooltip text="Просмотреть все комментарии">
                                <feather-icon icon="MessageSquareIcon" class="inline-block text-gray" svgClasses="w-8 h-8" />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <!-- <vs-pagination :max="5" :total="pagesTotal" v-model="page" class="mt-3"></vs-pagination> -->
    
        <vs-popup title="Комментарии пользователя" v-if="comments" :active.sync="commentsPopupView">
            <ol class="numerable">
                <li v-for="comment in comments" :key="`comment_item_`+comment.id" class="mb-2">
                    <b>{{ comment.createdAt | moment('DD.MM.YYYY HH:mm') }} - {{ comment.authorName }}</b>
                    <p>{{ comment.comment }}</p>
                </li>
            </ol>
        </vs-popup>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import qs from 'qs';
import axios from 'axios';

export default {
    name: 'accounting-return',
    data() {
        return {
            pageTitle: 'Возврат ушедших',
            users: [],
            comments: [],
            dateInterval: undefined,
            commentsPopupView: false,
            form: {
                date_time_from: undefined,
                date_time_to: undefined,
                statusId: undefined,
                brandTypes: undefined,
                adTypes: undefined,
            },
            dicts:{
                statuses: [],
                brandTypes: [],
                adTypes: [],
            },

            page: 1,
            pageSize: 25,
            pagesTotal: 1
        };
    },
    mounted() {
        this.loadDicts();
        this.setDefaultValues();
        this.get(true);
    },
    methods: {
        loadDicts() {
            this.axios
                .get('accounting/return-users/dicts')
                .then((dicts) => {
                    this.dicts.statuses = dicts.data.statuses;
                    this.dicts.brandTypes = dicts.data.brandTypes;
                    this.dicts.adTypes = dicts.data.adTypes;
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        get(reset) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            if (reset) {
                this.page = 1;
            }

            const params = {
                dateFrom: this.form.date_time_from,
                dateTo: this.form.date_time_to,
                statusId: this.form.statusId,
                brandTypeIds: this.form.brandTypes ? this.form.brandTypes.map((brandType) => brandType.id) : undefined,
                adTypeIds: this.form.adTypes ? this.form.adTypes.map((adType) => adType.id) : undefined,
                // page: this.page,
                // size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('accounting/return-users', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params,{ arrayFormat: 'repeat' });
                        }
                    }),
                    // this.axios.get('accounting/return-users/count', {
                    //     params: params,
                    //     paramsSerializer: (params) => {
                    //         return qs.stringify(params);
                    //     }
                    // })
                ])
                .then(
                    axios.spread((users/*, count*/) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        users.data.forEach(u => {
                            u.statusEdit = false;
                        });
                        this.users = users.data;
                        // this.pagesTotal = Math.ceil(count.data / this.pageSize);
                        this.pagesTotal = 1;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки пользователей.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        setDefaultValues() {
            let endDay = this.$moment(new Date());
            let endDayStr = endDay.format('YYYY-MM-DD HH:mm:ss');
            let startDay = endDay.add(-2, 'days');
            let startDayStr = startDay.format('YYYY-MM-DD HH:mm:ss');
            this.dateInterval = [startDayStr, endDayStr];
            this.form.date_time_from = this.$moment(this.dateInterval[0]).format('YYYY-MM-DD HH:mm:ss');
            this.form.date_time_to = this.$moment(this.dateInterval[1]).format('YYYY-MM-DD HH:mm:ss');
        },
        changeStatus(userId) {
            const selected = document.getElementById(`user-status-${userId}`).value;
            const status = this.dicts.statuses.find(s => s.id == selected);
            if (status) {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.$axios({
                    method: 'PATCH',
                    url: 'accounting/' + userId + '/status',
                    params: { userId: userId, statusId: status.id },
                    errors: this.errors,
                    success: () => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Статус пользователя успешно обновлен.",
                            color: "success",
                        });
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при обновлении статуса пользователя!",
                            color: "danger",
                        });
                    }
                })
            }
        },
        saveComment(userId, comment){
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'POST',
                url: 'accounting/return-users/' + userId + '/comments',
                params: { userId: userId, comment: comment },
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    const user = this.users.find(u => u.userId);
                    if (user) {
                        user.comment = '';
                    }
                    this.$vs.notify({
                        title: "Успешно сохранено",
                        text: "Комментарий успешно сохранен.",
                        color: "success",
                    });
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при сохранении комментария!",
                        color: "danger",
                    });
                }
            })
        },
        showComments(userId) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
    
            this.comments = [];
            this.axios.get(`accounting/return-users/${userId}/comments`)
                .then((resp) => {
                    this.comments = resp.data;
                    this.commentsPopupView = true;
                })
                .catch(err => {
                    this.$vs.notify({
                    title: 'Внимание!',
                    text: 'Ошибка загрузки комментариев.' + err.toString(),
                    color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        }
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    watch: {
        page: function () {
            this.get();
        },
        dateInterval: function (newTime) {
            this.form.date_time_from = this.$moment(newTime[0]).format('YYYY-MM-DD HH:mm:ss');
            this.form.date_time_to = this.$moment(newTime[1]).format('YYYY-MM-DD HH:mm:ss');
        }
    }
};
</script>

<style>
.date-p {
    display: block;
}
.b-btn {
    border-radius: 0;
    width: 200px;
}
.vs-pagination--mb {
    justify-content: center !important;
}
.comments-block {
    vertical-align: bottom;
}
</style>